import { types } from "../../types/types";

const initialState = {
  turnos: [],
  detalleComprobante: [],
  saldo: null,
  valorizacionTurno: null,
};

export const ctaCteReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ctaCteGetTurnosSaldoSuccess:
      return {
        ...state,
        saldo: action.payload,
      };
    case types.ctaCteGetTurnosSaldoError:
      return {
        ...state,
        saldo: null,
      };
    case types.ctaCteGetTurnoValorizacionSuccess:
      return {
        ...state,
        valorizacionTurno: action.payload,
      };
    case types.ctaCteGetTurnoValorizacionError:
      return {
        ...state,
        valorizacionTurno: null,
      };
    case types.ctaCteGetTurnosSuccess:
      return {
        ...state,
        turnos: action.payload,
      };
    case types.ctaCteGetTurnosError:
      return {
        ...state,
        turnos: [],
      };
    case types.ctaCteGetDetalleComprobanteSuccess:
      return {
        ...state,
        detalleComprobante: action.payload,
      };
    case types.ctaCteGetDetalleComprobanteError:
      return {
        ...state,
        detalleComprobante: [],
      };
    default:
      return state;
  }
};
